import { ApprovalsTab, COUNT_LIMIT } from "@/constants";

export const isApprovalTab = (tab?: string): boolean =>
  Object.values(ApprovalsTab).some(value => value === tab);

export const getLimitedCount = (count?: number): string => {
  if (count) {
    return count > COUNT_LIMIT ? `${COUNT_LIMIT}+` : `${count}`;
  }

  return "0";
};
